import React, { FC, useState } from 'react'
import cx from 'classnames'
import { useLocation } from 'react-router-dom'
import { Layer as LayerModel, GeometryTypes } from 'models/layer'
import { Checkbox } from 'components/Checkbox'
import { Tooltip } from 'components/Tooltip'
import { Icon } from 'components/Icon'
import { DownloadLayerDialog } from '../DownloadLayerDialog'
import { Flex } from 'components/Flex'
import { useTranslation } from 'react-i18next'
import { IconUtils } from 'utils/icon'
import { useProjectContext } from 'context/project-context'
import { useUserContext } from 'context/user-context'
import { useMapEditorContext } from 'context/map-editor-context'
import { StorageProvider } from 'providers/storage'

import styles from './Layer.module.scss'
//---ADD---
import { useLayerWidgets } from 'services/widget'
import { ApiProvider } from 'providers/request'
import { useFetchOrganization } from 'services/organization'
import { objectToFormData } from 'object-to-formdata'
import { Dialog } from 'components/Dialog'
import { Stack } from 'components/Stack'
import { Heading } from 'components/Heading'
import { Text } from 'components/Text'
import { Button } from 'components/Button'
//---ADD---
type LayerProps = {
  layer: LayerModel
  hasSelection?: boolean
  isSelected?: boolean
}
// The width of the layers group container is fixed,
// so we can just decide the maximum characters to show instead of having to do any calculations
const MAX_CHARACTERS = 29
export const Layer: FC<LayerProps> = ({ layer, hasSelection, isSelected = false }) => {
  const { t } = useTranslation()
  const [{ editingLayer }, mapEditorDispatch] = useMapEditorContext()
  const [{ activeLayers }, projectDispatch] = useProjectContext()
  const [openDialog, setOpenDialog] = useState(false)
  const hasProject = useLocation().pathname.includes('projects')
  const isActive = activeLayers.includes(layer.id)
  const [currentUser] = useUserContext()
  const { organization } = useFetchOrganization()

  //useStateDeleteCapa:
  const [dialogOpen, setDialogOpen] = React.useState<boolean>(false)

  //---ADD---
  const { widgets = [] } = useLayerWidgets(layer.id)
  //---ADD---
  function myFunction2(item: any) {
    projectDispatch.setFilters({
      sourceid: item.sourceid,
      column: item.column,
      operator: item.operator,
      filter: "[]", //null
    })
  }
  const onLayerChanged = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { checked } = event.target
    if (checked) {

      try {
        let userid = currentUser?.id
        let token = StorageProvider.get('token')
        const requestOptions = {
          method: 'POST', headers: {
            'Authorization': `JWT ${token}`
          }
        };
        fetch('https://0c58djfkue.execute-api.us-east-1.amazonaws.com/production/layerusage/' + layer.id + '/' + userid,
          requestOptions
        )

      }
      catch { }



      projectDispatch.selectLayer(layer.id)
      //layer.idLayerLabels = 698;

      if (layer.idlayerlabels !== undefined && layer.idlayerlabels !== null) {
        projectDispatch.selectLayer(layer.idlayerlabels)
      }

    } else {
      projectDispatch.deselectLayer(layer.id)
      if (layer.idlayerlabels !== undefined && layer.idlayerlabels !== null) {
        projectDispatch.deselectLayer(layer.idlayerlabels)
      }
      //Magia
      widgets.forEach(myFunction2);
      /*widgets.map(function (widget) {
        projectDispatch.setFilters({
          sourceid: widget.sourceid,
          column: widget.column,
          operator: widget.operator,
          filter: "", //null
        })
      })*/
      //Magia
      if (editingLayer?.id === layer.id) {
        mapEditorDispatch.cancelWizard()
      }
    }
  }
  const buttonClass = cx({
    [styles.button]: styles.button,
    [styles.selection]: hasSelection,
    [styles.active]: isSelected,
  })
  const layerName =
    layer.name.length <= MAX_CHARACTERS - 1 ? (
      layer.name
    ) : (
      <Tooltip label={layer.name} className={styles.labelTooltip} children={layer.name} />
    )
  const isDisabled = !layer?.viz?.source
  //const [searchParams] = useSearchParams()
  //const projectId = searchParams.get('projectId')
  var url = String(window.location);
  var urlbool = url.includes("app");
  var projectId = "";
  if (urlbool) {
    projectId = url.replace("https://app.descifra.global/projects/", "")
  } else {
    projectId = url.replace("https://staging.descifra.global/projects/", "")
  }

  const data = {
    borrar: true
  }

  const onDeleteDenue = async () => {
    try {
      await ApiProvider.post(`/layer/${layer.id}/orgs/${organization?.id}`, objectToFormData(data))
      window.location.reload()
    } catch (err) {
      console.log("Error de Delete Denue: " + JSON.stringify(err))
    }
  }

  return (
    <div className={styles.layer}>
      <Flex justify="between" align="center">
        <div className={styles.layerName}>
          <Checkbox
            label={layerName}
            disabled={isDisabled}
            checked={isActive}
            onChange={onLayerChanged}
            size="small"
          />
        </div>
        <div className={styles.iconsContainer}>
          {/* Layer color */}
          {layer.style && (
            <Icon
              name={IconUtils.getIconFromName(layer.style.icon)}
              className={styles.legendIcon}
              style={{ color: layer.style.color }}
            />
          )}
          {/* Add Feature */}
          {isActive &&
            layer.editable &&
            [GeometryTypes.Point, GeometryTypes.Polygon].includes(layer.geometryType) && (
              <Tooltip label={t(`panel.layers.${layer.geometryType}`)} direction="LEFT_CENTER">
                <button
                  aria-label={t(`panel.layers.${layer.geometryType}`)}
                  disabled={isDisabled}
                  onClick={() => mapEditorDispatch.editLayer(layer)}
                  className={buttonClass}
                >
                  <Icon
                    name={
                      layer.geometryType === GeometryTypes.Point ? 'map-pin-add-fill' : 'shape-fill'
                    }
                  />
                </button>
              </Tooltip>
            )}
          {/* Download data */}
          {hasProject && layer.file && layer.downloadable && (
            <Tooltip label={t('panel.layers.download')}>
              <button
                aria-label={t('panel.layers.download')}
                onClick={() => setOpenDialog(true)}
                className={styles.button}
              >
                <Icon name="download-line" />
              </button>
            </Tooltip>
          )}
          {/* Component to delete capas*/}
          <Dialog
            isOpen={dialogOpen}
            onClose={() => setDialogOpen(false)}
            aria-label="no se que va aqui"
          >
            <Stack space="medium">
              <Stack space="small">
                <Heading>Eliminar capa</Heading>
                <Text>¿Estás seguro de que deseas eliminar la capa <b>{layer.name}</b>?</Text>
              </Stack>
              <Stack space="medium">
                <Button onClick={() => setDialogOpen(false)} loading={false} variant="secondary" full>
                  No, mantener capa
                </Button>
                <Button onClick={() => onDeleteDenue()} loading={false} variant="danger" full>
                  Si, eliminar capa
                </Button>
              </Stack>
            </Stack>
          </Dialog>
          {/* Delete data Denue without project*/}
          {(layer.name.includes('Denue:') && !hasProject &&
            <Tooltip label={t('panel.layers.delete')}>
              <button
                aria-label={t('panel.layers.delete')}
                onClick={() => setDialogOpen(true)}
                className={styles.button}
              >
                <Icon name="delete-bin-5-line" />
              </button>
            </Tooltip>
          )}
          {/* Delete data Denue on a project*/}
          {(layer.name.includes('Denue:') && hasProject &&
            <Tooltip label={t('panel.layers.delete')}>
              <button
                aria-label={t('panel.layers.delete')}
                onClick={() => setDialogOpen(true)}
                className={styles.button}
              >
                <Icon name="delete-bin-5-line" />
              </button>
            </Tooltip>
          )}
          {/* Delete data Trade Areas without project*/}
          {((layer.name.includes('Trade Areas') || layer.name.includes('Área de impacto')) && !hasProject &&
            <Tooltip label={t('panel.layers.delete')}>
              <button
                aria-label={t('panel.layers.delete')}
                onClick={() => setDialogOpen(true)}
                className={styles.button}
              >
                <Icon name="delete-bin-5-line" />
              </button>
            </Tooltip>
          )}
          {/* Delete data Trade Areas on a project*/}
          {((layer.name.includes('Trade Areas') || layer.name.includes('Área de impacto')) && hasProject &&
            <Tooltip label={t('panel.layers.delete')}>
              <button
                aria-label={t('panel.layers.delete')}
                onClick={() => setDialogOpen(true)}
                className={styles.button}
              >
                <Icon name="delete-bin-5-line" />
              </button>
            </Tooltip>
          )}
          {/* Hide information icon for Busqueda Denue */}
          {(!layer.name.includes('Denue:') && !layer.name.includes('Trade Areas') && !layer.name.includes('Área de impacto') &&
            <Tooltip label={layer.description}>
              <Icon name="information-line" />
            </Tooltip>
          )}
        </div>
      </Flex>
      {hasProject && layer.file && (
        <DownloadLayerDialog
          isOpen={openDialog}
          onClose={() => setOpenDialog(false)}
          file={layer.file}
          layerid={layer.id}
          projectid={projectId}
        />
      )}
    </div>
  )
}
Layer.displayName = 'Layer'